export default "__VITE_ASSET__9fd569cb__"